module.exports = __webpack_public_path__ + "img/牛津（海南）.0e29ef59.png";